const authList = [
  {
    label: '服务质量',
    key: 'mass',
    id: '0',
    children: [
      {
        label: '客户资产统计',
        key: 'assetStatistics'
      },
      {
        label: '客户服务统计',
        key: 'serviceStatistic'
      },
      {
        label: '主动跟进统计',
        key: 'followStatistics'
      },
      {
        label: '任务数设置',
        key: 'task'
      }
    ]
  },
  // {
  //   label: '安全管控',
  //   key: 'control',
  //   children: [
  //     {
  //       label: '风险预警',
  //       key: 'index',
  //       children: [
  //         {
  //           label: '查看',
  //           key: 'warn'
  //         },
  //         {x`
  //           label: '对话详情',
  //           key: 'operating'
  //         },

  //         {
  //           label: '导出列表',
  //           key: 'warnExport'
  //         }
  //       ]
  //     },
  //     {
  //       label: '敏感操作',
  //       key: 'operationLog',
  //       children: [
  //         {
  //           label: '查看',
  //           key: 'operationLog'
  //         },
  //         {
  //           label: '查看详情',
  //           key: 'operationLogDetails'
  //         }
  //       ]
  //     },
  //     {
  //       label: '敏感词设置',
  //       key: 'wordSetting',
  //       children: [
  //         {
  //           label: '查看',
  //           key: 'wordSetting'
  //         },
  //         {
  //           label: '添加',
  //           key: 'wordAdd'
  //         },
  //         {
  //           label: '编辑',
  //           key: 'wordEdit'
  //         },
  //         {
  //           label: '删除',
  //           key: 'wordDel'
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    label: '风险预警',
    key: 'warn',
    id: '1',
    children: [
      {
        label: '风险预警',
        key: 'warn'
      },
      {
        label: '导出（风险列表）',
        key: 'warnExport'
      },
      {
        label: '导出（风险详情）',
        key: 'operating'
      }
    ]
  },
  {
    label: '内容审计',
    key: 'audit',
    id: '2',
    children: [
      {
        label: '内容审计',
        key: 'audit'
      },
      {
        label: '在职员工存档',
        key: 'auditOn'
      },
      {
        label: '离职员工存档',
        key: 'auditOff'
      },
      {
        label: '导出（导出含当前记录）',
        key: 'downLoadSession'
      }
    ]
  },
  {
    label: '敏感词设置',
    key: 'wordSetting',
    id: '3',
    children: [
      {
        label: '敏感词设置',
        key: 'wordSetting'
      },
      {
        label: '添加',
        key: 'wordAdd'
      },
      {
        label: '编辑',
        key: 'wordEdit'
      },
      {
        label: '删除',
        key: 'wordDel'
      }
    ]
  },
  {
    label: '敏感操作',
    key: 'operationLog',
    id: '4',
    children: [
      {
        label: '查看',
        key: 'operationLog'
      },
      {
        label: '查看详情',
        key: 'operationLogDetails'
      },
      {
        label: '删除提醒',
        key: 'details'
      }
    ]
  },
  {
    label: '离职继承',
    key: 'inherit',
    id: '5',
    children: [
      {
        label: '查看',
        key: 'inherit'
      },
      {
        label: '离职未被继承成员',
        key: 'inheritOff',
        children: [
          {
            label: '分配给其他成员',
            key: 'inheritOther'
          },
          {
            label: '分配',
            key: 'inheritOffOff'
          }
          // {
          //   label: '已分配',
          //   key: 'inheritOffOn'
          // }
        ]
      },
      {
        label: '离职已继承成员',
        key: 'inheritOn',
        children: [
          // {
          //   label: '详情',
          //   key: 'inheritOnDetail'
          // }
          {
            label: '详情',
            key: 'inheritView',
            children: [
              {
                label: '待分配客户',
                key: 'inheritKe'
              },
              {
                label: '待分配群聊',
                key: 'inheritGroup'
              }
            ]
          }
        ]
      },
      {
        label: '离职无资产成员',
        key: 'inheritOffNone'
      }
    ]
  },
  {
    label: '会话共享',
    key: 'sessionShare',
    id: '6',
    children: [
      {
        label: '查看',
        key: 'sessionShare',
        children: [
          {
            label: '操作',
            key: 'sessionShareOperation'
          }
        ]
      }
    ]
  },
  // {
  //   label: '系统管理',
  //   key: 'setting',
  //   id: '7',
  //   children: [
  //     {
  //       label: '管理员设置',
  //       key: 'user',
  //       children: [
  //         {
  //           label: '添加',
  //           key: 'userAdd'
  //         },
  //         {
  //           label: '设置角色',
  //           key: 'userEdit'
  //         },
  //         {
  //           label: '删除',
  //           key: 'userDel'
  //         }
  //       ]
  //     },
  //     {
  //       label: '角色权限',
  //       key: 'role',
  //       children: [
  //         {
  //           label: '添加角色',
  //           key: 'roleAdd'
  //         },
  //         {
  //           label: '编辑',
  //           key: 'roleEdit'
  //         },
  //         {
  //           label: '删除',
  //           key: 'roleDel'
  //         },
  //         {
  //           label: '权限设置',
  //           key: 'roleSetting'
  //         }
  //       ]
  //     },
  //     {
  //       label: '企业信息配置',
  //       key: 'company'
  //     },
  //     {
  //       label: '系统日志',
  //       key: 'system',
  //       children: [
  //         {
  //           label: '运行脚本',
  //           key: 'systemScript'
  //         },
  //         {
  //           label: '编辑',
  //           key: 'systemScriptEdit'
  //         },
  //         {
  //           label: '报错记录',
  //           key: 'systemErrorRecord'
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    label: '下载中心',
    key: 'downloadCenter',
    id: '8',
    children: [
      {
        label: '下载中心',
        key: 'downloadCenter'
      }]
  }
]
const authArr = []

authList.forEach((v, index) => {
  if (v.children) {
    for (const item of v.children) {
      authArr.push({
        ...item,
        parentId: index
      })
      if (item.children) {
        for (const min of item.children) {
          authArr.push({
            ...min,
            parentId: index
          })
        }
      }
    }
  }
})

export { authList, authArr }
